<template>
  <b-modal
    id="modal-vincular-producto"
    title="Vincular Productos"
    size="lg"
    hide-footer
    @hidden="limpiarCompleto"
  >
    <!-- Selector + Cantidad + Agregar/Actualizar -->
    <div class="d-flex align-items-center mb-3">
      <div class="flex-grow-1 mr-2">
        <multiselect2
          v-model="productoSelected"
          :options="productos"
          label="nombre"
          track-by="id"
          select-label=""
          deselect-label="X"
          placeholder="Selecciona un producto"
          :internal-search="false"
          :allow-empty="false"
          :loading="isLoadingComboProductos"
          @search-change="busquedadProductos"
          @open="mostrarListProductos('')"
          @select="obtenerDatoProductos"
        >
          <span slot="caret" v-if="!(productoSelected===null)"></span>
          <span slot="noResult">Sin Resultados</span>
          <span slot="noOptions">Lista Vacia</span>
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option.nombre }}
          </template>
          <template slot="afterList">
            <div class="row">
              <a
              v-if="showCargarMas"
              href="javascript:void(0)"
              class="col-sm-12 pl-5 py-1 text-dark font-weight-bold"
              @click="mostrarListProductos(null)">
              Cargar mas...
              </a>
            </div>
          </template>
        </multiselect2>
      </div>

      <div style="width:110px" class="mr-2">
        <b-form-input v-model.number="cantidad"
        type="number" min="1"
        placeholder="Cant."
        @keyup.enter="agregar"/>
      </div>
      <div style="width:110px" class="mr-2">
        <div class="row form-group" v-if="unidadMedida">
            <label class="radio radio-primary">
                <input type="radio" :value="unidadMedida" v-model="unidadMedidaModel">
                <span>{{ unidadMedida.descripcion }}</span>
                <span class="checkmark"></span>
            </label>
        </div>
        <div class="row form-group" v-if="unidadMedidaAlternativa">
            <label class="radio radio-primary">
                <input type="radio" :value="unidadMedidaAlternativa" v-model="unidadMedidaModel">
                <span>{{ unidadMedidaAlternativa.descripcion }}</span>
                <span class="checkmark"></span>
            </label>
        </div>
      </div>
      <b-button
        :variant="editIndex!==null?'warning':'success'"
        :disabled="!puedeAgregar"
        @click="agregar"
      >
        {{ editIndex!==null ? 'Actualizar' : 'Agregar' }}
      </b-button>
    </div>

    <!-- Lista -->
    <b-table small bordered hover :items="items" :fields="fields" @row-clicked="editar">
      <template #cell(cantidad)="r"><strong>{{ r.item.cantidad }}</strong></template>
      <template #cell(op)="r">
        <div class="text-right">
            <i
            class="nav-icon i-Close-Window font-weight-bold text-danger"
            style="cursor: pointer; font-size: 16px;"
            @click.stop="eliminar(r.index)"
            ></i>
        </div>
        </template>

    </b-table>

    <div class="d-flex justify-content-end mt-3">
      <b-button class="mr-2" variant="light" @click="cancelar">Cancelar</b-button>
      <b-button
        variant="success"
        :disabled="items.length===0"
        @click="confirmar"
      >
        Confirmar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from '@/modules/common/axiosERP';
import Multiselect2 from '@/components/util/vue-multiselect2';
import { util } from '@/plugins/util';

export default {
  name: 'ModalVincularProducto',
  props: {
    insumoId: {
      type: Number,
      required: false,
      default: null,
    },
    servicioData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  components: {
    Multiselect2,
  },
  data() {
    return {
      items: [],
      productos: [],
      productoSelected: null,
      cantidad: null,
      editIndex: null,
      fields: [
        {
          key: 'nombre', class: 'text-center', label: 'Producto', thStyle: { background: '#808080a6', padding: '4px' },
        },
        {
          key: 'cantidad', label: 'Cantidad', class: 'text-center', thClass: 'text-center', thStyle: { background: '#808080a6', padding: '4px' },
        },
        {
          key: 'op', label: '', thStyle: { width: '30px', background: '#808080a6' },
        },
      ],
      filter: '',
      temporalPageComboProducto: 0,
      totalRegistro: '',
      isLoadingComboProductos: false,
      delayTimeout: null,
      product: null,
      unidadMedidaModel: null,
      unidadMedida: null,
      unidadMedidaAlternativa: null,
      servicioComplementario: null,
      servicioDataLocal: [],
    };
  },
  watch: {
    // Limpiar cuando se abre el modal
    '$bvModal.isVisible': {
      handler(newVal) {
        if (newVal) {
          // Modal se abrió, limpiar datos
          this.limpiarCompleto();
        }
      },
      immediate: true,
    },
    // Observar cambios en el prop servicioData
    servicioData: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          // Crear una copia local para evitar mutar el prop
          this.servicioDataLocal = [...newVal];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    puedeAgregar() {
      return this.insumoId
        && this.productoSelected
        && Number.isFinite(this.cantidad)
        && this.cantidad > 0;
    },
    showCargarMas() {
      const isOkToSearch = this.temporalPageComboProducto * 100 < this.totalRegistro;
      return this.totalRegistro > 100 && isOkToSearch;
    },
  },
  methods: {
    // 1) Agregar o actualizar
    agregar() {
      if (!this.puedeAgregar) return;
      const esUnidadSecundaria = !!(this.unidadMedidaAlternativa
        && this.unidadMedidaModel?.id === this.unidadMedidaAlternativa?.id);
      const p = {
        id: this.productoSelected.id,
        nombre: this.productoSelected.nombre,
        cantidad: Number(this.cantidad),
        unidad_medida_id: this.unidadMedidaModel ? this.unidadMedidaModel.id : null,
        unidad_medida_descripcion: this.unidadMedidaModel ? this.unidadMedidaModel.descripcion : 'Unidad',
        unidad_principal: esUnidadSecundaria ? 0 : 1,
      };
      if (this.editIndex !== null) {
        this.$set(this.items, this.editIndex, p);
      } else {
        const i = this.items.findIndex((x) => x.id === p.id);
        if (i !== -1) this.$set(this.items, i, p);
        else this.items.push(p);
      }
      this.limpiar();
      this.$emit('input', this.items.map((x) => ({ ...x })));
    },

    // 2) Cargar fila para edición
    editar(item, idx) {
      this.editIndex = idx;
      this.productoSelected = this.obtenerDatoProductos(item);
      this.productoSelected = this.productos.find((x) => x.id === item.id) || { id: item.id, nombre: item.nombre };
      this.cantidad = item.cantidad;
    },

    // 3) Eliminar
    eliminar(idx) {
      this.items.splice(idx, 1);
      if (this.editIndex === idx) this.limpiar();
      // eslint-disable-next-line no-plusplus
      if (this.editIndex !== null && idx < this.editIndex) this.editIndex--;
    },

    // 4) Confirmar (emitir y cerrar)
    async confirmar() {
      if (!this.insumoId) {
        util.showNotify('No se ha seleccionado un insumo', 'error');
        return;
      }

      try {
        const payload = {
          insumo_id: this.insumoId,
          productos: this.items.map((item) => ({
            producto_id: item.id,
            cantidad: item.cantidad,
            estado: true,
            unidad_medida_id: item.unidad_medida_id || this.unidadMedidaModel?.id,
            unidad_principal: item.unidad_principal,
          })),
        };

        await axios.post('/clinic/servicio_complementario/producto_by_insumo', payload);

        this.$emit('confirmado', this.items.map((x) => ({ ...x })));
        this.$bvModal.hide('modal-vincular-producto');

        util.showNotify('Productos vinculados exitosamente', 'success');
      } catch (error) {
        util.showNotify(error.response?.data?.message || 'Error al vincular productos', 'error');
      }
    },

    // 5) Limpiar editor
    limpiar() {
      this.productoSelected = null;
      this.cantidad = null;
      this.editIndex = null;
    },

    // 6) Limpiar completamente el modal
    limpiarCompleto() {
      this.items = [];
      this.productoSelected = null;
      this.cantidad = null;
      this.editIndex = null;
      this.filter = '';
      this.temporalPageComboProducto = 0;
      this.totalRegistro = '';
      this.product = null;
      this.unidadMedidaModel = null;
      this.unidadMedida = null;
      this.unidadMedidaAlternativa = null;
      this.productos = [];
      this.servicioComplementario = null;
      this.servicioDataLocal = [];
    },

    // 7) Cancelar operación
    cancelar() {
      this.limpiarCompleto();
      this.$bvModal.hide('modal-vincular-producto');
    },
    busquedadProductos(query) {
      this.temporalPageComboProducto = 0;
      const DELAY = 400;
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(() => this.mostrarListProductos(query), DELAY);
    },
    async mostrarListProductos(query) {
      this.isLoadingComboProductos = true;
      this.filter = query;
      this.temporalPageComboProducto += 1;
      try {
        const REQUEST = {
          page: 1,
          perPage: 100 * this.temporalPageComboProducto,
          filterKey: this.filter,
        };
        const { data } = await axios.get('/configuration/tipoProducto/combo', { params: REQUEST });
        this.productos = data.data.data;
        this.totalRegistro = data.data.total;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isLoadingComboProductos = false;
      }
    },
    async obtenerDatoProductos(producto) {
      try {
        const RESPONSE = await axios.get(`/inventario/getDataByProductos/${producto.id}`);
        const DATA = RESPONSE.data.data;
        this.product = DATA.producto;
        this.unidadMedidaModel = DATA.unidad_medida;
        this.unidadMedida = DATA.unidad_medida;
        this.unidadMedidaAlternativa = DATA.unidad_medida_alternativa;
      } catch (error) {
        const FALLO_VALIDACION = 422;
        if (error.response.status !== FALLO_VALIDACION) {
          util.showNotify(error.response.data.message, 'error');
        } else {
          Object.entries(error.response.data.data).forEach(([, mensajes]) => {
            mensajes.forEach((texto) => util.showNotify(texto, 'error'));
          });
        }
        this.reset();
      }
    },
    reset() {
      this.cantidad = 1;
      this.productoSelected = null;
      this.product = null;
      this.unidadMedidaModel = null;
      this.unidadMedida = null;
      this.unidadMedidaAlternativa = null;
      this.temporalPageComboProducto = 0;
    },
    async cargarProductosDisponibles() {
      await this.mostrarListProductos('');
    },
    cargarDatosServicio(servicioData) {
      this.servicioComplementario = servicioData;

      const productosServicio = servicioData.productos || servicioData;
      if (productosServicio && Array.isArray(productosServicio)) {
        this.servicioDataLocal = [...productosServicio];

        this.items = this.servicioDataLocal.map((producto) => ({
          id: producto.producto_id,
          nombre: producto.producto,
          cantidad: producto.cantidad || 1,
          unidad_medida_id: producto.unidad_medida_id || null,
          unidad_medida_descripcion: producto.unidad_medida_descripcion || 'Unidad',
        }));
      }
    },
  },
};
</script>
